<template>
  <div class="detail-items-table">
    <div class="detail-items-table-header flex px-20 py-10 text-14">
      <div class="items-table-c1">{{ $t('来源') }}</div>
      <div class="items-table-c2">
        <el-row class="cursor-pointer" align="middle" @click.stop="changeSort('price')">
          <span class="mr-3">{{ $t('售价') }}</span>
          <sortarrow :sort-type="sortData['price']" />
        </el-row>
      </div>
      <div class="items-table-c3">{{ $t('求购价') }}</div>
      <div class="items-table-c4">{{ $t('当前在售') }}</div>
      <div class="items-table-c5">{{ $t('当前求购') }}</div>
      <div class="items-table-c6"></div>
      <div class="items-table-c7"></div>
    </div>

    <div v-if="pageLoading" class="bg-white">
      <CommonLoading />
    </div>
    <div v-else class="bg-white pl-20 pr-20">
      <template v-if="newList && newList[0]">
        <div v-for="(item, index) in newList" :key="index" class="table-item flex h-76 items-center">
          <div class="items-table-c1 text-color-lightgray flex items-center">
            <i class="iconfont icon-guanfangmeiti mr-5 text-26" :class="`icon-${item.platform}`"></i>
            <span class="text-16">{{ item.platformName }}</span>
          </div>
          <div class="items-table-c2 text-color-orange text-16">{{ monetaryUnit() }} {{ currencyTransform(item.price) }}</div>
          <div class="items-table-c3 text-color-orange text-16">{{ monetaryUnit() }} {{ currencyTransform(item.biddingPrice) }}</div>
          <div class="items-table-c4 text-14">{{ item.sellCount }}{{ $t('件') }}</div>
          <div class="items-table-c5 text-14">{{ item.biddingCount }}{{ $t('件') }}</div>
          <div class="items-table-c6 text-14"></div>
          <div class="items-table-c7">
            <a :href="item.link" target="_blank">
              <div class="action-btn text-color-primary w-130 cursor-pointer text-center"><i class="iconfont icon-gouwuche"></i> {{ $t('前去购买') }}</div>
            </a>
          </div>
        </div>
      </template>
      <empty v-else />
    </div>
  </div>
</template>

<script setup>
import { formatSortVal } from '~/utils/index'
import sortarrow from '~/components/common/sortarrow.vue'
import empty from '~/components/common/empty.vue'
import { getItemOnsale } from '~~/api/steam'
const props = defineProps({
  list: {
    type: Array,
    default: []
  },
  itemId: {
    type: String,
    default: ''
  }
})
const newList = ref(props.list)

const { data: tempList } = await getItemOnsale({ itemId: props.itemId })
newList.value = JSON.parse(JSON.stringify(tempList))
const sortData = ref({})

const pageLoading = ref(false)

const changeSort = curkey => {
  const sortType = formatSortVal(sortData.value[curkey])

  sortData.value[curkey] = sortType
  if (sortType === 'ASC') {
    newList.value = newList.value.sort((a, b) => Number(a.price) - Number(b.price))
  } else if (sortType === 'DESC') {
    newList.value = newList.value.sort((a, b) => Number(b.price) - Number(a.price))
  } else {
    newList.value = JSON.parse(JSON.stringify(tempList))
  }
}
</script>

<style lang="scss" scoped>
.detail-items-table {
  .detail-items-table-header {
    background-color: #fff;
    border-top: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
  }

  .action-btn {
    width: 130px;
    height: 36px;
    line-height: 36px;
    border-radius: 4px;
    border: 1px solid #0252d9;
  }

  .items-table-c1 {
    width: 140px;
  }
  .items-table-c2 {
    width: 138px;
  }
  .items-table-c3 {
    width: 138px;
  }
  .items-table-c4 {
    width: 136px;
  }
  .items-table-c5 {
    width: 76px;
  }
  .items-table-c6 {
    width: 106px;
  }
 
}
.table-item:not(:last-child) {
  border-bottom: 1px solid #eff1f5;
}
</style>
